// extracted by mini-css-extract-plugin
export default {"buttonDefault":"ButtonDefault_buttonDefault__0mqdH"};